export const props = {
  // Values
  list: Array,
  listInit: {
    type: Boolean,
    default: true
  },
  translation: {
    type: Array,
    default: ['text']
  },
  keyText: {
    type: String,
    default: 'text'
  },
  keyValue: {
    type: String,
    default: 'value'
  }
}
